import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/CommissionReport/CommissionReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class CommissionReportActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/CommissionReport/CommissionReport")
	}

	render() {
		return (
			<Activity 
				name="CommissionReport"
				RenderedComponent={this.RenderedComponent}
				context="CommissionReport"
				action="CommissionReport"
				formActions={FormAction}/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(CommissionReportActivity)